export const alwaysAllowedKeys = [
  'Escape',
  'Backspace',
  'Tab',
  'ArrowLeft',
  'ArrowRight',
]
